import { EVENT_TYPES } from '../../reducer'

export const annualInflationCheckboxLabel = {
  [EVENT_TYPES.INCOME]: 'Apply Annual Increase to Income',
  [EVENT_TYPES.EXPENSE]: 'Apply Annual Inflation to Expense'
}

export const annualInflationValueLabel = {
  [EVENT_TYPES.INCOME]: 'Annual Increase %',
  [EVENT_TYPES.EXPENSE]: 'Annual Inflation %'
}
